export default __webpack_public_path__ + "static/media/04.a81f168a.png";